import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { WalletAccountingSyncApiAdapter } from '../adapters';
import type { BuildPendingAccountingRequest, BuildPendingAccountingResponse } from '../models';

export const useBuildPendingAccounting = () => {
  const queryClient = useQueryClient();
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const adapter = useMemo(() => new WalletAccountingSyncApiAdapter(httpClient), [httpClient]);

  return useMutation<BuildPendingAccountingResponse, Error, BuildPendingAccountingRequest>({
    mutationFn: (body) => adapter.buildPending(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['wallet-accounting-sync-transactions-infinite'] });
    },
  });
};
